// extracted by mini-css-extract-plugin
export default {"root":"NotificationsMain_root__8S-cm"};